import { Registry } from '@tencent/workbench-core';
import { MiddlewareProvider } from '../providers/middleware/middleware-provider.js';

const MiddlewareRegistry = new Registry(MiddlewareProvider);

export { MiddlewareRegistry };
//# sourceMappingURL=middleware-registry.js.map
